module.exports = __webpack_public_path__ + "static/img-community.e5aabe31.jpg";